import type { ReactNode } from 'react';

export const symbol_compass_calibration: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M344.5-135.5Q288-192 288-271t56.5-135.5Q401-463 480-463t135.5 56.5Q672-350 672-271t-56.5 135.5Q559-79 480-79t-135.5-56.5Zm229-42Q612-216 612-271t-38.5-93.5Q535-403 480-403t-93.5 38.5Q348-326 348-271t38.5 93.5Q425-139 480-139t93.5-38.5ZM376-561q-50 19-92 53-9 8-20.5 7t-19.5-9L104-650q-10-10-9.5-23.5T106-695q81-65 175.5-105T480-840q104 0 198.5 40T854-695q11 8 11.5 21.5T856-650L716-510q-8 8-19.5 9t-20.5-7q-42-34-92-53t-104-19q-54 0-104 19Zm-110-12q51-32 104-49.5T480-640q57 0 111 16t103 51l97-97q-66-51-146.5-80.5T480-780q-84 0-164 29.5T169-670l97 97Zm214-67Zm0 369Z"
		/>
	</svg>
);
